export const CursorTypes = {
  POINTER: "POINTER",
  DEFAULT: "DEFAULT",
};

export const INITIAL_STATE = {
  type: CursorTypes.DEFAULT,
};
